var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 342.6 467.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#82c48c;}.cls-2{fill:#6dc77a;}.cls-3{fill:#25252d;}.cls-4,.cls-9{fill:#fff;}.cls-5{fill:#e1e4fe;}.cls-6{fill:#cdcdcf;}.cls-7{fill:#373635;}.cls-8{fill:#21201f;}.cls-8,.cls-9{opacity:0.5;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 105") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.78,
    y: 17.85,
    width: 329.38,
    height: 399.3,
    rx: 22.29
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.69,373.55v23.74a22.29,22.29,0,0,1-22.29,22.28H31.59A22.28,22.28,0,0,1,9.31,397.29V373.55a22.28,22.28,0,0,0,22.28,22.29H316.4A22.29,22.29,0,0,0,338.69,373.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M316.05,424.62H30A26.58,26.58,0,0,1,3.46,398.07V42.6A26.58,26.58,0,0,1,30,16.05h286A26.58,26.58,0,0,1,342.6,42.6V398.07A26.58,26.58,0,0,1,316.05,424.62ZM30,25.05A17.57,17.57,0,0,0,12.46,42.6V398.07A17.57,17.57,0,0,0,30,415.62h286a17.57,17.57,0,0,0,17.55-17.55V42.6a17.57,17.57,0,0,0-17.55-17.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.08,215.46a2.5,2.5,0,0,1-2.5-2.5V154.73a2.5,2.5,0,0,1,5,0V213A2.5,2.5,0,0,1,174.08,215.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.08,243.72a2.5,2.5,0,0,1-2.5-2.5V229a2.5,2.5,0,0,1,5,0v12.23A2.5,2.5,0,0,1,174.08,243.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.08,261.64a2.5,2.5,0,0,1-2.5-2.5v-3.57a2.5,2.5,0,0,1,5,0v3.57A2.5,2.5,0,0,1,174.08,261.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174.16,203.13a2.49,2.49,0,0,1-2.5-2.5V142.41a2.5,2.5,0,0,1,5,0v58.22A2.49,2.49,0,0,1,174.16,203.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M174,222.56a2.5,2.5,0,0,1-2.5-2.5v-7.83a2.5,2.5,0,0,1,5,0v7.83A2.5,2.5,0,0,1,174,222.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M289.57,376.07H59.25c-9.7,0-17.58-4.46-17.6-14.72L41,69.57A14.35,14.35,0,0,1,55.33,55.18H292.15A14.36,14.36,0,0,1,306.5,69.5l.67,287.91C307.19,367.71,299.31,376.07,289.57,376.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "304.49 381.66 42.67 382.6 41.92 369.53 307.44 369.53 304.49 381.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M306,389.83H36.13l-.07-4.57L35.3,50.75l4.58-.07H309.73l.1,4.54.74,330v4.5Zm-261-9H301.56l-.72-321.15H44.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 141.93,
    y: 169.24,
    width: 99.57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 141.93,
    y: 206.86,
    width: 63.29,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 141.93,
    y: 247.71,
    width: 99.57,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 141.93,
    y: 289.27,
    width: 63.29,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 72.07,
    y: 41.31,
    width: 207.37,
    height: 54,
    rx: 27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M279.44,66.06a27,27,0,0,1-27,27H99.07A26.95,26.95,0,0,1,72.79,59.88,27,27,0,0,0,99.07,80.69H252.43a27,27,0,0,0,26.29-20.81A26.87,26.87,0,0,1,279.44,66.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M252.43,99.82H99.07a31.51,31.51,0,0,1,0-63H252.43a31.51,31.51,0,1,1,0,63Zm-153.36-54a22.51,22.51,0,0,0,0,45H252.43a22.51,22.51,0,1,0,0-45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.6,185a14,14,0,1,1,14-14A14.06,14.06,0,0,1,110.6,185Zm0-23.07a9,9,0,1,0,9,9A9.06,9.06,0,0,0,110.6,162Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.6,225.14a14,14,0,1,1,14-14A14,14,0,0,1,110.6,225.14Zm0-23.06a9,9,0,1,0,9,9A9,9,0,0,0,110.6,202.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.6,265.25a14,14,0,1,1,14-14A14,14,0,0,1,110.6,265.25Zm0-23.06a9,9,0,1,0,9,9A9,9,0,0,0,110.6,242.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.6,305.37a14,14,0,1,1,14-14A14.06,14.06,0,0,1,110.6,305.37Zm0-23.07a9,9,0,1,0,9,9A9.06,9.06,0,0,0,110.6,282.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 175.68,
    cy: 31.1,
    r: 26.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M201.36,30.37A26.6,26.6,0,1,1,149,23.8a26.6,26.6,0,0,0,51.56,0A26.34,26.34,0,0,1,201.36,30.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M175.68,62.2a31.1,31.1,0,1,1,31.1-31.1A31.13,31.13,0,0,1,175.68,62.2Zm0-53.2a22.1,22.1,0,1,0,22.1,22.1A22.13,22.13,0,0,0,175.68,9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 317.55,
    y: 87.25,
    width: 7,
    height: 55.42
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 317.39,
    y: 153.55,
    width: 7,
    height: 12.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 317.55,
    y: 179.71,
    width: 7,
    height: 17.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 116.29,
    y: 458.21,
    width: 92.82,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 92.83,
    y: 458.21,
    width: 11,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 221.57,
    y: 458.21,
    width: 12.69,
    height: 9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 155.97,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 180.86,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 205.79,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    y: 230.72,
    width: 12.46,
    height: 12.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 259.46,
    y: 415.54,
    width: 12.46,
    height: 12.46,
    transform: "translate(687.46 156.07) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 234.57,
    y: 415.54,
    width: 12.46,
    height: 12.46,
    transform: "translate(662.57 180.96) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 216.77,
    y: 408.41,
    width: 12.46,
    height: 26.71,
    transform: "translate(644.77 198.77) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 184.72,
    y: 415.54,
    width: 12.46,
    height: 12.46,
    transform: "translate(612.72 230.82) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 20.93,
    y: 279.8,
    width: 7,
    height: 55.47
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 20.75,
    y: 346.32,
    width: 7,
    height: 11.12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 95.47,
    y: 69.73,
    width: 55.47,
    height: 7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 161.98,
    y: 69.9,
    width: 11.12,
    height: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.72baf28d37b620dc9c3717884e0af781.svg";
export { ForwardRef as ReactComponent };